const sizes = {
  contentMaxWidth: "1000px",
  contentPadding: "48px",
  contentPaddingSmall: "20px",
  borderRadius: "9px"
};
export default sizes;